<div class="row mb-3">
  <div class="col-12">
    <app-date-range-selector (dateChanged)="updateDate($event)" [date]="'this-month'"
      [initialFrom]="filters['date']?.from ?? ''" [initialTo]="filters['date']?.to ?? ''"
      [zone]="'Europe/Paris'"></app-date-range-selector>
  </div>
</div>

<div class="row mb-3">
  <div class="col-3">
    <label class="form-label fw-bold small">Brand</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-box"></i></span>
      <select class="form-select" [(ngModel)]="filters['productId']" [ngModelOptions]="{standalone: true}" (ngModelChange)="changeProduct()">
        <option [ngValue]="null">{{ getProductPlaceholder() }}</option>
        @for (product of products; track product) {
          <option [ngValue]="product.id"> {{ product.name }}</option>
        }
      </select>
    </div>
  </div>

  <div class="col-3">
    <label class="form-label fw-bold small">Offer</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-basket"></i></span>
      <select class="form-select" [(ngModel)]="filters['offerId']" [ngModelOptions]="{standalone: true}" [appElementLoader]="offerLoading"
        (ngModelChange)="changeOffer()">
        <option [ngValue]="null">{{ getOfferPlaceholder() }}</option>
        @for (offer of offers; track offer) {
          <option [ngValue]="offer.id">{{ offer.name }}</option>
        }
      </select>
    </div>
  </div>

  <div class="col-3">
    <label class="form-label fw-bold small">Language</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-translate"></i></span>
      <app-dropdown-select [(ngModel)]="filters['lang']" [ngModelOptions]="{standalone: true}">
        <app-dropdown-select-option [value]="null">All languages</app-dropdown-select-option>
        @for (lang of languages; track lang) {
          <app-dropdown-select-option [value]="lang.isoCode">
            <img [ngSrc]="langService.getLanguageFlag(lang)" [alt]="lang.name" class="country-flag"
              width="24" height="24">
            {{ lang.name }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>
    </div>
  </div>

  <div class="col-3">
    <label class="form-label fw-bold small">Country</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
      <app-dropdown-select [(ngModel)]="filters['country']" [ngModelOptions]="{standalone: true}">
        <app-dropdown-select-option [value]="null">All countries</app-dropdown-select-option>
        @for (country of countries; track country) {
          <app-dropdown-select-option [value]="country.isoCode">
            <img [ngSrc]="countryService.getFlag(country.isoCode)" [alt]="country.name"
              class="country-flag"
              width="24" height="24">
            {{ country.name }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>
    </div>
  </div>
</div>

<div class="row mb-3">
  <div class="col-3">
    <label for="id" class="form-label">ID</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-filter"></i></span>
      <input type="text" class="form-control" [(ngModel)]="filters['id']" [ngModelOptions]="{standalone: true}">
    </div>
  </div>

  <div class="col-3">
    <label for="accountType" class="form-label fw-bold small">Account Type</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-people"></i></span>
      <select class="form-select" id="accountType" [(ngModel)]="filters['accountType']" [ngModelOptions]="{standalone: true}"
        (ngModelChange)="refreshPartners()">
        <option [ngValue]="null">All account types</option>
        @for (accountType of partnerAccountTypeList; track accountType) {
          <option
            [ngValue]="accountType">{{ 'partnerAccountType.' + accountType | translate }}
          </option>
        }
      </select>
    </div>
  </div>

  <div class="col">
    <label class="form-label fw-bold small">Partner</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
      <select class="form-select" [(ngModel)]="filters['partnerId']" [ngModelOptions]="{standalone: true}" [appElementLoader]="partnerLoading">
        <option [ngValue]="null">{{ getPartnerPlaceholder() }}</option>
        @for (partner of partners; track partner) {
          <option [ngValue]="partner.id">{{ partner }}</option>
        }
      </select>
    </div>
  </div>

  @if (hasLandingPage) {
    <div class="col">
      <label class="form-label fw-bold small">Promotion link</label>
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
        <select class="form-select landing-page-activity" [(ngModel)]="filters['landingPageActiveSince']" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="refreshLandingPages()" title="Only promotion links with at least 1 click since…">
          <option [ngValue]="null">Activity</option>
          @for (period of activityPeriods; track period.identifier) {
            <option [ngValue]="period.identifier">{{ period.shortLabel }}</option>
          }
        </select>
        <select class="form-select" [(ngModel)]="filters['landingPageId']" [ngModelOptions]="{standalone: true}"
          [appElementLoader]="landingPageLoading">
          <option [ngValue]="null">{{ getLandingPagePlaceholder() }}</option>
          @for (landingPage of landingPages; track landingPage) {
            <option [ngValue]="landingPage.id">{{ landingPage }}</option>
          }
        </select>
      </div>
    </div>
  }
</div>

<div class="row mb-3">
  <div class="col">
    <label class="form-label fw-bold small">SubID</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-filter"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters['subid']" [ngModelOptions]="{standalone: true}">
    </div>
  </div>

  <div class="col">
    <label class="form-label fw-bold small">Tracker 1</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters['tc1']" [ngModelOptions]="{standalone: true}">
    </div>
  </div>
  <div class="col">
    <label class="form-label fw-bold small">Tracker 2</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters['tc2']" [ngModelOptions]="{standalone: true}">
    </div>
  </div>
  <div class="col">
    <label class="form-label fw-bold small">Tracker 3</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters['tc3']" [ngModelOptions]="{standalone: true}">
    </div>
  </div>
  <div class="col">
    <label class="form-label fw-bold small">Tracker 4</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters['tc4']" [ngModelOptions]="{standalone: true}">
    </div>
  </div>
</div>
<ng-content></ng-content>
